import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DIALOG_DATA, IconModule } from '@hglobal/fin-ui';
import { TranslatePipe } from '@ngx-translate/core';

import { InfoDialogContentComponent } from '@zeusm/shared/common';
import { DialogData } from '@zeusm/shared/core/entities';
import { SupportLinkService, SupportLinkSource } from '@zeusm/shared/core/services';

@Component({
  selector: 'zeusm-personal-cards-error-dialog',
  imports: [IconModule, InfoDialogContentComponent, TranslatePipe],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardsErrorDialogComponent {
  readonly #supportLinkService = inject(SupportLinkService);
  readonly #dialog = inject<DialogData<CardsErrorDialogComponent, { errorText: string }>>(DIALOG_DATA);
  errorText = this.#dialog?.data.errorText;
  readonly supportUrl = this.#supportLinkService.generateUrl({
    source: SupportLinkSource.CardsErrorDialog,
    error: this.errorText,
  });
}
